









































import { Component, Prop, Vue } from 'vue-property-decorator'
import MenusStore from '@/store/modules/MenusStore'
import CategoriesStore from '@/_common/api/store/modules/CategoriesStore'

@Component({
    components: {
    },
})
export default class Navigator extends Vue {

    @Prop() private isPage!: string;
    @Prop() private pageTitle!: string;
    @Prop() private pageTitleBefore!: string;
    @Prop() private pageTitleAfter!: string;

    get menuId(): number {
        return Number(this.$route.params.menuId);
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[this.menuId] || {};
    }

    get dispPreview(): boolean {
        return CategoriesStore.all.length > 0;
    }
}
